<template>
	<section>
		<el-form inline>
			<el-form-item>
				<el-input v-model.trim="filters.name" placeholder="标题" clearable @input="getList()"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getList">查询</el-button>
			</el-form-item>
		</el-form>
		<el-row v-for="(item,index) in lists" :key="index">
			<p class="title">{{item.catalog_name}}</p>
			<el-table ref="table1" :data="item.list" :show-header="false">
				<el-table-column label="图标">
					<template slot-scope="scope">
						<div class="items">
							<el-image class="img" fit="fill" :src="scope.row.icon_path"></el-image>
							<div>
								<p>{{scope.row.name}}</p>
								<p style="color:#A7A7A7">{{scope.row.description}}</p>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="tofill(scope.row)">填写</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>

		<form-preview :visible.sync="drawerVisible" :form-data="formData" @submit="submit" type="fill" size="50%" />
	</section>
</template>

<script>
	import { cms_form } from "@/api/cms";
	import formPreview from "@/components/form_custom/preview/index.vue";
	import { canUseInPC } from "@/components/form/parser/handle_sheme"
	export default {
		data() {
			return {
				filters: {
					type: 1,
					name: null,
				},
				loading: false,
				lists: [],

				drawerVisible: false,
				formData: null,
			};
		},

		components: { formPreview },
		computed: {},

		methods: {
			submit() {
                this.drawerVisible=false
				this.$router.push({ name: "formMyHistory" });
			},
			tofill(data) {
				this.formData = null;
				let full_loading = this.$loading({
					lock: true,
					text: "正在获取",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				});
				cms_form.get({ id: data._id || data.id }).then((res) => {
					full_loading.close();
					if (res.data) {
						this.formData = res.data;
						if (!canUseInPC(this.formData.config)) {
							this.$alert("当前表单不支持浏览器，请到手机上进行填写", "提示")
							return
						}
						this.drawerVisible = true;
					}
				});
			},

			getList() {
				let param = Object.assign(this.filters);
				this.loading = true;
				cms_form.groupByCatalog(param).then((res) => {
					this.loading = false;
					if (res.data) {
						this.lists = res.data;
					}
				});
			},
		},

		mounted() {
			this.getList();
		},
	};
</script>

<style scoped lang="scss">
	.el-button--text {
		color: #007aff;
	}
	.items {
		display: flex;
		align-items: center;
		.img {
			width: 42px;
			height: 42px;
			border-radius: 4px;
			margin-right: 10px;
			flex-shrink: 0;
		}
	}
	el-image /deep/ .el-image__inner {
		height: unset;
	}
	.el-form-item {
		margin-bottom: 10;
	}

	.title {
		font-size: 14px;
		color: #333333;
		line-height: 2;
		font-weight: 550;
	}
</style>



// WEBPACK FOOTER //
// src/components/form_custom/my/index.vue